import { render } from "./HelpGeneralMfaPolicy.vue?vue&type=template&id=af3784b6&scoped=true"
import script from "./HelpGeneralMfaPolicy.vue?vue&type=script&lang=js"
export * from "./HelpGeneralMfaPolicy.vue?vue&type=script&lang=js"

import "./HelpGeneralMfaPolicy.vue?vue&type=style&index=0&id=af3784b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af3784b6"]])

export default __exports__